import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: 'export-nested-object',
  templateUrl: './template.html',
  styleUrls: ['./style.scss'],
})
export class ExportNestedObjectComponent implements OnChanges{
  type: 'object' | 'array' | 'primitive';

  typeOf: string;


  ngOnChanges(changes: SimpleChanges): void {
    this.type = Array.isArray(this.obj) ? 'array' :  typeof this.obj === 'object' ? 'object' : 'primitive';
    this.typeOf = typeof this.obj;
  }
  @Input()
  obj: unknown;

  isObjectEmpty(obj: unknown): boolean {
    if (
      obj === null ||
      obj === undefined ||
      (Array.isArray(obj) && obj.length === 0) ||
      (typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0)
    ) {
      return true;
    }
    return false;
  }

  typeof(value: unknown) {
    if (value === null) {
      return 'undefined'
    }
    return typeof value;
  }
}